import { ContainerComponent, wrap } from "AppReact";
import Controller from "./controller";
import internalState from "./internalState";
import { FlexCenterWrapper, Td, Th, WorkOrderRowWrapper, Mr5, DisplayInlineTooltipWrapper, InlineBlockWrapper, TrainingVideoRowWrapper, CustomPositionAbsoluteWrapper } from "wrappers";
import { SecondaryTextSm, Icon, ImagePreviewCard, ImagePreviewPlaceholderCard, Tooltip, ProgressBar } from "atoms";
import { textEllipsis } from 'utils/ellipsis';
import { RatingV2, CopyLinkOutlineButton } from "molecules";
import { format } from "date-fns";
import { StarSvg } from "components/icons";
import { MarginRight18, PreviewThumbnailWrapper } from "./wrappers";
import { capitalize, percentageCalculator, isViewportGreaterThan } from "utils";
import { VIDEO_STATUS_MAP } from "../../modals/trainingVideoModal/contants";

export const definition = {
  name: "TrainingVideoTableRow",
  controller: Controller,
  initialProps: ({ training, uploadingTracker }) => ({
    training, uploadingTracker
  }),
  props: internalState,
  elements: [
    {
      wrapper: TrainingVideoRowWrapper,
      name: "Wrapper",
      isButton: true,
      bindings: ({ training }) => ({ training }),
      elements: [
        {
          wrapper: wrap(FlexCenterWrapper, Th),
          name: "ThumbnailWrapper",
          elements: [
            {
              name: "PreviewThumbnail",
              component: wrap(
                wrap(ImagePreviewCard, PreviewThumbnailWrapper),
                MarginRight18
              ),
              renderIf: ({ training }) => !!training?.thumbnail_url,
              displayValue: ({ training}) => training?.thumbnail_url ?? ""
            },
            {
              name: "PreviewThumbnail",
              component: wrap(
                wrap(ImagePreviewPlaceholderCard, PreviewThumbnailWrapper),
                MarginRight18
              ),
              renderIf: ({ training }) => !training?.thumbnail_url,
              displayValue: ({ training}) => training?.thumbnail_url ?? ""
            },
            {
              name: "CopyButton",
              component: CopyLinkOutlineButton,
              bindings: ({ linkCopied, training, uploadingTracker }) => {
                const isProcessing = training.status === VIDEO_STATUS_MAP.PROCESSING.toLowerCase()
                const isError = isProcessing ? false : training.status === VIDEO_STATUS_MAP.FAILED.toLowerCase() || (training.status === VIDEO_STATUS_MAP.LOADING && training.id !== uploadingTracker?.video_id)
                const isLoading = isError ? false : training?.status === VIDEO_STATUS_MAP.LOADING
                const stateText = isProcessing ? "Processing" : isError ? "Upload Failed" : isLoading ? "Loading" : "Copy Link"
                return ({
                isProcessing,
                isError,
                isLoading,
                link: training.slug,
                linkCopied,
                label: stateText,
                linkCopiedStateText: "Link Copied",
              })},
            },
          ],
        },
        {
          wrapper: wrap(DisplayInlineTooltipWrapper, Td),
          name: "VideoNameTooltip",
          elements: [
            {
              component: wrap(SecondaryTextSm, InlineBlockWrapper),
              name: "VideoName",
              displayValue: ({ training }) => {
                const isMedium = isViewportGreaterThan({ pixels: 1679 })
                const isLarge = isViewportGreaterThan({ pixels: 1919 })
                let limit = 8
                if(isMedium) limit = 30;
                if(isLarge) limit = 100;
                return training?.title ? textEllipsis(training?.title, limit) : "N/A";
              },
            },
            {
              component: Tooltip,
              name: 'Popup',
              renderIf: ({ training }) => training?.title?.length > 0,
              displayState: () => ({ whiteSpace: "no-wrap"}),
              displayValue: ({ training }) => training?.title ?? ""
            }
          ]
        },
        {
          component: wrap(SecondaryTextSm, Td),
          name: "Trainer",
          displayValue: ({ training }) => training?.trainer_name ?? "N/A",
        },
        {
          component: wrap(SecondaryTextSm, Td),
          name: "Category",
          displayValue: ({ training }) => training?.category_name ?? "N/A",
        },
        {
          component: wrap(SecondaryTextSm, Td),
          name: "Views",
          displayValue: ({ training }) => {
            return training?.num_views ? `${training?.num_views}` : "0"
          },
        },
        {
          component: wrap(RatingV2, Td),
          name: "Ratings",
          bindings: ({ training }) => {
            return { ratings: training?.ratings };
          },
        },
        {
          component: wrap(SecondaryTextSm, Td),
          name: "publishDate",
          displayValue: ({ training }) => {
            return training?.publish_date
              ? format(new Date(training?.publish_date), "yyyy/MM/dd")
              : "N/A";
          },
        },
        {
          wrapper: Td,
          name: "FeaturedButtonWrapper",
          isButton: true,
          bindings: ({ training }) => ({ training }),
          elements: [
            {
              component: Icon,
              name: "Featured",
              displayValue: ({ training }) =>
                StarSvg({ width: 20, height: 20, filled: training?.is_highlighted }),
            },
          ]
        },
        {
          component: wrap(SecondaryTextSm, Td),
          name: "Status",
          displayValue: ({ training, uploadingTracker }) => {
            const isError = training.status === VIDEO_STATUS_MAP.FAILED.toLowerCase() || (training.status === VIDEO_STATUS_MAP.LOADING && training.id !== uploadingTracker?.video_id)
            const isLoading = isError ? false : training?.status === VIDEO_STATUS_MAP.LOADING
            
            if(isError) {
              return VIDEO_STATUS_MAP.FAILED

            } if(isLoading) {
              return "Loading"
            }

            return capitalize(training?.status ?? "")
          },
        },
        {
          wrapper: CustomPositionAbsoluteWrapper,
          name: "ProgressWrapper",
          renderIf: ({ uploadingTracker }) => {
            return !!uploadingTracker;
          },
          displayState:() => ({ bottom: "0px", right: "0px", left: "0px", top: "" }),
          elements: [
            {
              component: ProgressBar,
              name: "Progress",
              displayValue: ({}) => "",
              displayState: ({ uploadingTracker }) => {
                const tracker = uploadingTracker ? uploadingTracker : {
                  id: "",
                  uploadedChunks: 0,
                  totalChunks: 0,
                  finalStatus: "",
                };
                const percent = tracker ? parseFloat(
                  percentageCalculator(
                    tracker?.totalChunks ?? 0,
                    tracker?.uploadedChunks ?? 0,
                  )
                ): 0;
                return {
                  progress: percent
                };
              },
            },
          ]
        },
      ],
    },
  ],
};

export default ContainerComponent(definition);
